import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { api } from '../../utils/api';

// Async thunk for fetching users
export const fetchUsers = createAsyncThunk(
  'users/fetchUsers',
  async ({ searchTerm, page, limit = 10 }) => {
    const data = await api.post('/users/search', {
      searchTerm,
      page,
      limit
    });

    return { ...data, searchTerm, page };
  }
);

const usersSlice = createSlice({
  name: 'users',
  initialState: {
    users: [],
    searchTerm: '',
    page: 1,
    totalPages: 0,
    total: 0,
    loading: false,
    error: null,
    searchPerformed: false,
    usersPerPage: 10,
  },
  reducers: {
    setSearchTerm: (state, action) => {
      state.searchTerm = action.payload;
    },
    setPage: (state, action) => {
      state.page = action.payload;
    },
    clearSearch: (state) => {
      state.users = [];
      state.searchTerm = '';
      state.page = 1;
      state.totalPages = 0;
      state.total = 0;
      state.searchPerformed = false;
      state.error = null;
    },
    updateUser: (state, action) => {
      const { userId, updates } = action.payload;
      const userIndex = state.users.findIndex(user => user.id === userId);
      if (userIndex !== -1) {
        state.users[userIndex] = { ...state.users[userIndex], ...updates };
      }
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchUsers.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchUsers.fulfilled, (state, action) => {
        state.loading = false;
        state.users = action.payload.users;
        state.total = action.payload.total;
        state.totalPages = Math.ceil(action.payload.total / state.usersPerPage);
        state.searchTerm = action.payload.searchTerm;
        state.page = action.payload.page;
        state.searchPerformed = true;
        state.error = null;
      })
      .addCase(fetchUsers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
        state.searchPerformed = true;
      });
  }
});

export const { setSearchTerm, setPage, clearSearch, updateUser } = usersSlice.actions;
export default usersSlice.reducer;
